// These are currently coming from the node_modules folder.
import "angular";
import "angular-animate";

import "angular-cookies";
import "angular-sanitize";

import "angular-ui-bootstrap";
import "angular-ui-router";
import "angular-ui-switch";

import "ng-infinite-scroll";

// translation dependencies
import "angular-translate";
import "angular-translate-loader-static-files";
import "angular-translate-storage-cookie";
import "angular-translate-storage-local";

import "moment";
import "moment-duration-format";
import "clipboard";
import "lru-cache";
import "lodash";
import "node-uuid";
import "turf";
import "papaparse";
import "file-saver";

// ui-select css and js
import "ui-select";
import "ui-select/dist/select.css";

import "angular-ui-switch/angular-ui-switch.css";

import "./css/bootstrap/bootstrap.css";

// TODO: make all vendor files from npm and the node_modules folder.
import "./js/vendor/angular-translate-handler-log/angular-translate-handler-log.js";
import "./js/vendor/angular-dynamic-locale/dist/tmhDynamicLocale.js";
import "./js/vendor/ui-utils.min.js";
import "./js/vendor/angular-visibility-change.min.js";


// WEBPACK FOOTER //
// ./vendor.js